import http from "@/utils/http";
let host = "/oaApi/nvc/public";
export default {
  // 根据工号查询子女投保信息
  queryEmployeeChild: data =>
    http.post(`/carApi/employeeChild/queryByPageList`, data),
  // 新增编辑子女投保信息
  addOrUpdateEmployeeChild: data =>
    http.post(`/carApi/employeeChild/addOrUpdate`, data),
  // 新增推荐时间设置
  pushScheduleAddOrUpdate: data =>
    http.post(`/carApi/pushSchedule/addOrUpdate`, data),
  // 查询时间设置
  queryPushSchedule: data =>
    http.post(`/carApi/pushSchedule/queryByPageList`, data),
  // 保单查询
  queryByPagePolicyList: data =>
    http.post(`/carApi/policy/queryByPageList`, data),
  //导出子女
  exportEmployeeChild: data =>
    http.post(`/carApi/employeeChild/export`, data, {
      responseType: "blob"
    }),
  //导出模板
  downExcel: () =>
    http.get(`/carApi/policy/downExcel`, {
      responseType: "blob"
    }),
  // 导入商保
  importPolicy: data =>
    http.post(`/carApi/policy/importPolicy`, data.file, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }),
  // 获取用户信息
  queryByUsernames: data => http.post(`/carApi/user/queryByUsername`, data),
  // 搜索人员
  quaGetEmployeeInfo: data =>
    http.post(`${host}/api/cic/index/getEmployeeInfo`, data)
};
